export default {
  current: 'Bieżące',
  noActiveRecipe: 'Brak aktywnej receptury na tym piecu.',
};
